export const MIN_TABLE_HEIGHT = 400;
